import styled from '@emotion/styled/macro'
import { BoxProps } from '@rebass/grid/emotion'
import { AutoStack } from 'components'
import { Box } from 'grid'
import { themeColor, themeFont } from 'mixins'
import { IStackProps } from 'office-ui-fabric-react'
import * as React from 'react'

export const Page: React.FC<BoxProps> = ({ css, ...props }) => (
  <Box px={3} pt={1} pb={2} {...props} />
)

export const SectionBox = styled(Box)`
  position: relative;
  border: 1px solid ${themeColor('neutralSecondary')};

  .composite-field,
  .ms-Dropdown-container,
  .ms-TextField-wrapper {
    display: flex;
    flex-wrap: wrap;

    .ms-Label {
      flex: 0 0 130px;
      margin-right: 5px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .ms-Label + * {
      flex: 1 0;
      min-width: 200px;
    }
  }

  .ms-Dropdown-title,
  .ms-BasePicker-text,
  .ms-TextField-fieldGroup {
    /* border-color: ${themeColor('neutralTertiary')}; */
  }
`
export const SectionLabel = styled.div`
  ${themeFont('mediumPlus')};
  font-weight: 200;
  background: white;
  position: absolute;
  top: ${({ theme }) => -(theme.space![2] + 5)}px;
  left: ${({ theme }) => theme.space![2]}px;
  padding: 3px;
`
export const Section: React.FC<
  { label: string; stack?: boolean | Omit<IStackProps, 'children'> } & BoxProps
> = ({ label, stack, children, css, ...props }) => {
  return (
    <SectionBox pt={3} pb={2} px={2} mt={3} mb={4} {...props}>
      <SectionLabel>{label}</SectionLabel>
      {stack !== false ? (
        <AutoStack tokens={{ childrenGap: 4 }} {...stack}>
          {children}
        </AutoStack>
      ) : (
        children
      )}
    </SectionBox>
  )
}

export const SimpleSection: React.FC<
  { label: string; stack?: boolean | Omit<IStackProps, 'children'> } & BoxProps
> = ({ label, stack, children, css, ...props }) => {
  return (
    <SectionBox pt={3} pb={2} px={2} mt={3} mb={4} {...props}>
      <SectionLabel>{label}</SectionLabel>
      {children}
    </SectionBox>
  )
}
